import { createApi } from "../axiosInstance";

const api = createApi("myBusiness");

// Fresh implementation per mybusiness.md §3 — not copied from apis/MyFPO/fpoApi.js. Mirrors
// fpo's FPOEntity lifecycle (same field set, same approve/reject flow) but targets /company.
export const getCompanies = () => api.get("/company");
export const getCompanyById = (id) => api.get(`/company/${id}`);
export const createCompany = (data) => api.post("/company", data);
export const updateCompany = (id, data) => api.patch(`/company/${id}`, data);
export const deleteCompany = (id) => api.delete(`/company/${id}`);
// Same shape as fpo's: { bankDetails: [{ id?, bankName, ... }], deletedBankDetails: [id] }
export const updateCompanyBankDetails = (companyId, data) => api.patch(`/company/${companyId}/bank-details`, data);

export const createAnonymousCompany = (data) => api.post("/company/anonymous", data);

export const getCompaniesByStatus = (status) => api.get(`/company?status=${status}`);
export const approveCompany = (companyId, data) => api.patch(`/company/${companyId}/approve`, data);
export const rejectCompany = (companyId, data) => api.patch(`/company/${companyId}/reject`, data);

// Named `downloadCompany` (not `downloadCompanyRegistration`) to avoid colliding with
// complianceApiFactory's `downloadCompanyRegistration` (a different, proxied compliance
// sub-document) once both are re-exported through this same apis/MyBusiness barrel.
//
// Verified against the real CompanyController.downloadCompany (mybusiness backend): `format` is
// a required query param (not optional), `companyId` is optional (omit to download all).
export const downloadCompany = (format, companyId = null) => {
  const params = { format };
  if (companyId) params.companyId = companyId;
  return api.get("/company/download", { params, responseType: "blob" });
};
